// src/brands.js
//
// Brands to show in the "Brands I've Worked With" wall on the homepage.
//
// To add one:
//   1. Drop the logo in public/
//   2. Add a line below.
//
//   name  the brand, used as the image alt text — required, and it is what a
//         screen reader announces, so write it as you would say it
//   src   path from public/, e.g. "/acme.png"
//   href  optional; links the logo to their site
//
// Leave the array empty and the whole section is skipped, so the page is never
// left with a heading over a blank space.
//
// These arrive as 500x500 tiles, most with the brand's own background colour
// baked in, and several are white type on that colour. So the wall renders them
// as square tiles in full colour rather than the greyscale-on-white treatment a
// set of transparent marks would get — see BrandWall.css.
//
// One practical note: showing a client's logo as a credential normally needs
// their sign-off, and some brands publish brand-usage rules that govern it.
// Worth a quick check per logo before this goes live.

const brands = [
  { name: "Collarts", src: "/collarts.png" },
  { name: "July", src: "/july.png" },
  { name: "R U OK?", src: "/ruok.png" },
  { name: "Good Pair Days", src: "/gpd.png" },
  { name: "World of Music", src: "/wom.png" },
  { name: "Lygon", src: "/lygon.png" },
  { name: "RACT", src: "/ract.png" },
  { name: "URBNSURF", src: "/urbnsurf.png" },
  { name: "The Fibreglass Shop", src: "/fgs.png" },
  { name: "Tactile Toys", src: "/tactoys.png" },
];

export default brands;
